const routerNL = {
    "releases": {
        "view": {
            "name": "Releases",
            "buttonText": "Nieuwe Release Toevoegen",
            "secondaryButtonText": "Release Overdragen",
            "headerText": "Releases"
        },
        "add": {
            "name": "Nieuwe Release Toevoegen",
            "headerText": "Releases"
        },
        "update": {
            "name": "Release Bijwerken",
            "headerText": "Releases"
        },
        "details": {
            "name": "Release Details",
            "headerText": "Releases"
        },
        "transfer": {
            "name": "Release Overdragen",
            "headerText": "Releases"
        },
        "tracks": {
            "name": "Tracklijst",
            "headerText": "Releases"
        },
        "deliveryConfirmation": {
            "name": "Geleverde Lijst",
            "headerText": "Geleverde Lijst"
        },
        "storeDeliveryList": {
            "name": "Winkel Leveringslijst",
            "headerText": "Winkel Leveringslijst"
        }
    },
    "copyrightInfringements": {
        "view": {
            "name": "Auteursrecht Inbreuken",
            "headerText": "Auteursrecht Inbreuken"
        }
    },
    "escrowWallet": {
        "view": {
            "name": "Escrow Portemonnee",
            "headerText": "Escrow Portemonnee"
        }
    },
    "artists": {
        "view": {
            "name": "Artiesten",
            "buttonText": "Nieuwe Artiest Toevoegen",
            "headerText": "Artiesten"
        },
        "add": {
            "name": "Nieuwe Artiest Toevoegen",
            "headerText": "Artiesten"
        },
        "update": {
            "name": "Artiest Bijwerken",
            "headerText": "Artiesten"
        },
        "viewDetails": {
            "name": "Bekijk Artiest Details",
            "headerText": "Bekijk Artiest Details"
        },
        "wishlist": {
            "name": "Artiesten Verlanglijst",
            "headerText": "Artiesten Verlanglijst"
        },
        "addFromWishlist": {
            "name": "Artiest Toevoegen Van Verlanglijst",
            "headerText": "Artiest Toevoegen Van Verlanglijst"
        }
    },
    "trends": {
        "view": {
            "name": "Trends",
            "headerText": "Trends"
        }
    },
    "earningsDrilldown": {
        "view": {
            "name": "Inkomsten",
            "headerText": "Inkomsten Drilldown"
        }
    },
    "accounting": {
        "view": {
            "name": "Slimme Boekhouding",
            "headerText": "Slimme Boekhouding",
            "buttonText": "Nieuwe Boekhouding Toevoegen"
        },
        "add": {
            "name": "Nieuwe Boekhouding Toevoegen",
            "headerText": "Nieuwe Boekhouding Toevoegen"
        },
        "breakdown": {
            "name": "Boekhouding Uitsplitsing",
            "headerText": "Boekhouding Uitsplitsing"
        }
    },
    "invoices": {
        "view": {
            "name": "Facturen",
            "headerText": "Facturen",
            "buttonText": "Factuur Toevoegen"
        },
        "add": {
            "name": "Factuur Toevoegen",
            "headerText": "Factuur Toevoegen"
        }
    },
    "musicLink": {
        "view": {
            "name": "Muziek Link",
            "buttonText": "Nieuwe Muziek Link Toevoegen",
            "headerText": "Muziek Link",
            "secondaryButtonText": "Muziek Link Url"
        },
        "add": {
            "name": "Muziek Link Toevoegen",
            "headerText": "Muziek Link"
        },
        "update": {
            "name": "Muziek Link Bijwerken",
            "headerText": "Muziek Link"
        },
        "viewStats": {
            "name": "Muziek Link Bekijk Statistieken",
            "headerText": "Muziek Link Bekijk Statistieken"
        }
    },
    "musicLinkUrlpart": {
        "view": {
            "name": "Muziek Link Urlgedeelte",
            "buttonText": "Nieuwe Muziek Link Urlgedeelte Toevoegen",
            "headerText": "Muziek Link Urlgedeelte"
        },
        "add": {
            "name": "Nieuwe Muziek Link Urlgedeelte Toevoegen",
            "headerText": "Muziek Link Urlgedeelte"
        },
        "update": {
            "name": "Muziek Link Urlgedeelte Bijwerken",
            "headerText": "Muziek Link Urlgedeelte"
        }
    },
    "linkLandingPage": {
        "view": {
            "name": "Link Landingspagina",
            "buttonText": "Link Landingspagina Toevoegen",
            "headerText": "Link Landingspagina"
        },
        "add": {
            "name": "Link Landingspagina Toevoegen",
            "headerText": "Link Landingspagina"
        },
        "update": {
            "name": "Link Landingspagina Bijwerken",
            "headerText": "Link Landingspagina"
        },
        "viewAnalytics": {
            "name": "Link Landingspagina Analyse",
            "headerText": "Link Landingspagina"
        }
    },
    "mastering": {
        "view": {
            "name": "Mastering",
            "buttonText": "Mastering Toevoegen",
            "headerText": "Audio Mastering"
        },
        "add": {
            "name": "Mastering Toevoegen",
            "headerText": "Audio Mastering"
        },
        "update": {
            "name": "Mastering Bijwerken",
            "headerText": "Audio Mastering"
        },
        "viewSongs": {
            "name": "Audio Mastering Nummers",
            "headerText": "Audio Mastering Nummers"
        }
    },
    "featureRequest": {
        "view": {
            "name": "Functie Aanvraag",
            "buttonText": "Nieuwe Functie Aanvraag",
            "headerText": "Functie Aanvraag"
        },
        "add": {
            "name": "Functie Aanvraag Toevoegen",
            "headerText": "Functie Aanvraag"
        }
    },
    "scWhitelist": {
        "view": {
            "name": "SC Whitelist",
            "headerText": "SC Whitelist"
        }
    },
    "profile": {
        "view": {
            "name": "Profiel",
            "headerText": "Mijn Profiel"
        }
    },
    "announcements": {
        "view": {
            "name": "Aankondigingen",
            "headerText": "Aankondigingen"
        }
    },
    "twoFactorAuthentication": {
        "view": {
            "name": "Twee-Factor Authenticatie",
            "headerText": "Twee-Factor Authenticatie"
        }
    },
    "completeYourInformation": {
        "view": {
            "name": "Voltooi Uw Informatie",
            "headerText": "Voltooi Uw Informatie"
        }
    },
    "tokens": {
        "view": {
            "name": "Tokens",
            "headerText": "Tokens"
        }
    },
    "orderTokens": {
        "view": {
            "name": "Tokens Bestellen",
            "headerText": "Tokens Bestellen"
        }
    },
    "accessKeys": {
        "view": {
            "name": "Toegangssleutels",
            "headerText": "Toegangssleutels"
        }
    },
    "paymentMethods": {
        "view": {
            "name": "Betaalmethoden",
            "buttonText": "Betaalmethode Toevoegen",
            "headerText": "Mijn Betaalmethoden"
        },
        "add": {
            "name": "Betaalmethode Toevoegen",
            "headerText": "Mijn Betaalmethoden"
        },
        "update": {
            "name": "Betaalmethode Bijwerken",
            "headerText": "Mijn Betaalmethoden"
        }
    },
    "orderCredits": {
        "view": {
            "name": "Bestel Credits",
            "headerText": "Bestel Credits"
        }
    },
    "purchaseHistory": {
        "view": {
            "name": "Aankoopgeschiedenis",
            "headerText": "Aankoopgeschiedenis"
        }
    },
    "subscription": {
        "view": {
            "name": "Mijn Abonnement",
            "headerText": "Mijn Abonnement"
        },
        "upgrade": {
            "name": "Abonnement Upgraden",
            "headerText": "Abonnement Upgraden"
        }
    },
    "subUsers": {
        "view": {
            "name": "Subgebruikers",
            "buttonText": "Nieuwe Subgebruiker Toevoegen",
            "headerText": "Mijn Subgebruikers"
        },
        "add": {
            "name": "Nieuwe Subgebruiker Toevoegen",
            "headerText": "Mijn Subgebruikers"
        },
        "edit": {
            "name": "Subgebruiker Bewerken",
            "headerText": "Mijn Subgebruikers"
        }
    },
    "labels": {
        "view": {
            "name": "Labels",
            "buttonText": "Nieuw Label Toevoegen",
            "headerText": "Mijn Labels"
        },
        "add": {
            "name": "Nieuw Label Toevoegen",
            "headerText": "Mijn Labels"
        },
        "edit": {
            "name": "Label Bewerken",
            "headerText": "Mijn Labels"
        }
    },
    "statements": {
        "view": {
            "name": "Uitspraken",
            "headerText": "Financiële Uitspraken"
        }
    },
    "subuserStatements": {
        "viewParentUser": {
            "name": "Subgebruiker Uitspraken",
            "headerText": "Subgebruiker Uitspraken"
        },
        "viewSubuser": {
            "name": "Gebruiker Uitspraken",
            "headerText": "Gebruiker Uitspraken"
        }
    },
    "dashboard": {
        "view": {
            "name": "Startpagina",
            "headerText": "Startpagina"
        }
    }
};

export default routerNL;